import { BrowserRouter as Router } from "react-router-dom";
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "./App.css";
import AppRoutes from "./AppRoutes";
import { getEntraClientId, getEntraTenantId } from "./utils/runtimeConfig";

const tenantId = getEntraTenantId();
const clientId = getEntraClientId();

const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

// Set active account on successful login so acquireTokenSilent works
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }
});

// The whole app is the auth-gated control plane.
// Routing sends everything under the protected areas.
const App: React.FC = () => {
  return (
    <Router>
      <MsalProvider instance={msalInstance}>
        <AppRoutes />
      </MsalProvider>
    </Router>
  );
};

export default App;
